import { useContainerWidth } from '@fs/zion-ui'
import useSourceCentricDetailsFlag from '../../data-service/useSourceCentricDetailsFlag'
import preferenceKeys from '../preference-keys'
import { useColumnLayout } from '../../providers/ColumnLayoutProvider'

export function getColumnLayoutFromStorage(): 'single' | 'double' {
  try {
    const raw = localStorage.getItem(preferenceKeys.COLUMN_LAYOUT)
    if (raw) {
      const parsed = JSON.parse(raw)
      if (parsed === 'single' || parsed === 'double') return parsed
    }
  } catch {
    // ignore parse errors
  }
  return 'double'
}

export function useCardSkeletonColumns(totalColumns: number): number {
  const atWidth = useContainerWidth()
  const sourceCentricFlag = useSourceCentricDetailsFlag()
  const columnLayout = sourceCentricFlag.data?.isOn ? 'double' : getColumnLayoutFromStorage()
  return atWidth({ default: totalColumns, md: columnLayout === 'double' ? totalColumns / 2 : totalColumns })
}

export default function useSingleOrDoubleColumns(totalColumns: number): number {
  const [columnLayoutSetting] = useColumnLayout()
  const sourceCentricFlag = useSourceCentricDetailsFlag()
  const atWidth = useContainerWidth()
  const effectiveLayout = sourceCentricFlag.data?.isOn ? 'double' : columnLayoutSetting
  return atWidth({
    default: totalColumns,
    md: effectiveLayout === 'double' ? totalColumns / 2 : totalColumns,
  })
}
